module.exports = __webpack_public_path__ + "static/sport/h5out5.62f0c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/h5out5.png
// module id = WH1e
// module chunks = 0